/**Panel - PO Workbench - Update the PO fields and ASN for the item which will take time to deliver */

/**Import the packages, Action and Store*/
import React, { Component } from 'react';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import { withTranslation, Trans } from 'react-i18next';
import MultiSelect from "react-multi-select-component";
import Select from 'react-select'
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { RotatingLines } from 'react-loader-spinner';

import * as POWorkbenchAction from '../actions/POWorkbenchAction';
import * as MenuAction from '../actions/MenuAction';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import * as OrderStatusAction from '../actions/OrderStatusAction';

import POWorkbenchStore from '../stores/POWorkbenchStore';
import OrderStatusStore from '../stores/OrderStatusStore';
import NonCatalogStore from '../stores/NonCatalogStore';

let currentPagePath;

let shiptoglobVar = "";
let poglobVar = "";
let vendorNameglobVar = "";
let installStoreglobVar = "";
let workOrderglobVar = "";
let workOrderstatusglobVar = "";
let techNameglobVar = "";
let problemCodeglobVar = "";
let installCustglobVar = "";

let ispageload = true;

class POWorkbenchComponent extends Component {
    constructor(props) {
        super(props);
        this.handleDatePicker = this.handleDatePicker.bind(this);
        this.applyFilterClick = this.applyFilterClick.bind(this);

        /** intilize the variable used in this component * */
        this.state = {
            VendorNameOptions: [],
            ShipToLocationOptions: [],
            ProblemCodeOptions: [],
            InstallStoreOptions: [],
            WOStatusOptions: [],
            TechNameOptions: [],
            InstallCustomerOptions: [],
            LineWOStatusOptions: [],
            LineFreightOptions: [],
            GridData: [],
            gridLineItemData: [],
            PageNo: 1,
            SortType: "DESC",
            SortColumn: "DUE_DT",
            poNumber: "",
            workOrder: "",
            selectedShipTo: "",
            selectedVendor: "",
            selectedProblemCode: [],
            selectedInstallCustomer: "",
            selectedInstallStore: "",
            selectedWOstatus: "",
            selectedTechName: "",
            gridLineIndex: null,
            selectedIndex: null,
            popupVendorDetail: {},
            historyData: [],
            mindate: new Date()

        }
    }

    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        POWorkbenchAction.getCurrentFavPage(getFavPageBO);

        POWorkbenchAction.PageLoadAction();

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        POWorkbenchStore.on('poWorkbenchPageLoad', this.PageLoadResponse.bind(this));
        POWorkbenchStore.on('poWorkbenchGridLoad', this.applyFilterClickResponse.bind(this));
        POWorkbenchStore.on('poWorkbenchSave', this.saveButtonResponse.bind(this));
        OrderStatusStore.on('PassThroughAuthe', this.incidentClickResponse.bind(this));
        POWorkbenchStore.on('poWorkbenchGetHistory', this.HistoryClickResponse.bind(this));
        NonCatalogStore.on('attachmentResponse', this.attachmentResponse.bind(this));
        POWorkbenchStore.on('favpage', this.loadFavPageResponse.bind(this));
        POWorkbenchStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }

    componentWillUnmount() {
        POWorkbenchStore.removeListener('poWorkbenchPageLoad', this.PageLoadResponse.bind(this));
        POWorkbenchStore.removeListener('poWorkbenchGridLoad', this.applyFilterClickResponse.bind(this));
        POWorkbenchStore.removeListener('poWorkbenchSave', this.saveButtonResponse.bind(this));
        OrderStatusStore.removeListener('PassThroughAuthe', this.incidentClickResponse.bind(this));
        POWorkbenchStore.removeListener('poWorkbenchGetHistory', this.HistoryClickResponse.bind(this));
        NonCatalogStore.removeListener('attachmentResponse', this.attachmentResponse.bind(this));
        POWorkbenchStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        POWorkbenchStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));

        shiptoglobVar = "";
        poglobVar = "";
        vendorNameglobVar = "";
        installStoreglobVar = "";
        workOrderglobVar = "";
        workOrderstatusglobVar = "";
        techNameglobVar = "";
        problemCodeglobVar = "";
        installCustglobVar = "";
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(POWorkbenchStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };

    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        if (POWorkbenchStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(POWorkbenchStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(POWorkbenchStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "PO Workbench",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            POWorkbenchAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            POWorkbenchAction.deleteFavPage(deleteFavPageBO)
        }
    };

    PageLoadResponse = () => {
        let response = JSON.parse(POWorkbenchStore.PageLoadData);
        ispageload = true;
        const { t } = this.props;

        // Error handling
        if (response.errorDt[0].errorFlag.toUpperCase() === "TRUE") {
            swal({
                allowOutsideClick: true,
                closeOnClickOutside: true,
                text: t('Technical issue please contact SDI help desk')
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');

            return;
        }

        // Define a mapping configuration for each table
        const mappings = {
            VendorNameTbl: item => ({
                value: item.VENDOR_ID,
                label: `${item.NAME1}-${item.VENDOR_ID}`
            }),
            ShipToTbl: item => ({
                value: item.LOCATION,
                label: item.DESCRIPTION
                
            }),
            InstallStoreTbl: item => ({
                value: item.LOCATION,
                label: item.STORE1
            }),
            WoStatusTbl: item => ({
                value: item.ISA_WO_STATUS,
                label: item.ISA_WO_STATUS
            }),
            TechNameTbl: item => ({
                value: item.ISA_EMPLOYEE_ID,
                label: item.ISA_EMPLOYEE_NAME
            }),
            ProblemCodeTbl: item => ({
                value: item.ISA_PROBLEM_CODE,
                label: item.DESCR
            }),
            InstallCustomerTbl: item => ({
                value: item.LOCATION,
                label: item.LOCATION
            }),
            FreightTbl: item => ({
                value: item.SHIP_TYPE_ID,
                label: item.DESCRSHORT
            }),
            ReasonTbl: item => ({
                value: item.REASON_CD,
                label: item.DESCRLONG
            })
        };

        // Process data using a single loop
        const processedData = Object.entries(mappings).reduce((acc, [key, transformFn]) => {
            const dataArray = Array.isArray(response[key]) ? response[key].map(transformFn) : [];
            // Only prepend 'Select' if the key is not 'ProblemCodeTbl'
            acc[key] = key === 'ProblemCodeTbl' ? dataArray : [{ value: '', label: 'Select' }, ...dataArray];
            return acc;
        }, {});

        // Update state with processed data
        this.setState({
            VendorNameOptions: processedData.VendorNameTbl,
            ShipToLocationOptions: processedData.ShipToTbl,
            ProblemCodeOptions: processedData.ProblemCodeTbl,
            InstallStoreOptions: processedData.InstallStoreTbl,
            WOStatusOptions: processedData.WoStatusTbl,
            TechNameOptions: processedData.TechNameTbl,
            InstallCustomerOptions: processedData.InstallCustomerTbl,
            LineReasonOptions: processedData.ReasonTbl,
            LineFreightOptions: processedData.FreightTbl
        });

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    onChangeField = (name, event, index) => {
        const { gridLineItemData } = this.state;
        const updatedData = [...gridLineItemData];
        let trackingErrorMsg = '';

        // Helper function to validate tracking numbers
        const validateTrackingNumber = (provider, trackingNumber) => {
            if (provider.includes('UPS')) {
                if (trackingNumber.length === 12) {
                    if (!(trackingNumber.startsWith("T") && trackingNumber.endsWith('"'))) {
                        return 'Must include \'T\' at start and (\") as the 12th character';
                    }
                } else if (trackingNumber.length === 18) {
                    if (!trackingNumber.startsWith("1Z")) {
                        return 'Must include \'1\' at start and (Z) as the 2nd character';
                    }
                } else if (![9, 11, 12, 18].includes(trackingNumber.length)) {
                    return 'Not a valid UPS tracking number';
                }
            } else if (provider.includes('FEDEX')) {
                if (!provider.includes('FEDEX FRGT') && ![10, 12, 15].includes(trackingNumber.length)) {
                    return 'Not a valid FEDEX tracking number';
                }
            }
            return '';
        };

        switch (name) {
            case "PONumber":
                this.setState({ poNumber: event.target.value });
                break;

            case "WOOrder":              
                let value = event.target.value;

                if (value.trim() === "") {
                    this.setState({
                        workOrder: "",
                        isWOStatusDDVisible: false,
                        selectedWOstatus: []
                    });
                } else if (!isNaN(Number(value))) {
                    this.setState({
                        workOrder: Number(value),
                        isWOStatusDDVisible: true,
                        selectedWOstatus: []
                    });
                }
                break;

            case "SelectedLineFreight":
                const freightProvider = event.value;
                const trackingNumber = updatedData[index].TEMP_ISA_ASN_TRACK_NO;

                if (trackingNumber) {
                    trackingErrorMsg = validateTrackingNumber(freightProvider, trackingNumber);
                }

                updatedData[index] = {
                    ...updatedData[index],
                    FREIGHT_PROVIDER: freightProvider,
                    TEMP_FREIGHT_PROVIDER: freightProvider,
                    trackingErrorMsg
                };
                this.setState({ gridLineItemData: updatedData, gridLineIndex: index });
                break;

            case "TrackingNumber":
                const trackingNum = event.target.value;
                const freightProviderForTracking = updatedData[index].TEMP_FREIGHT_PROVIDER;

                if (freightProviderForTracking) {
                    trackingErrorMsg = validateTrackingNumber(freightProviderForTracking, trackingNum);
                }

                updatedData[index] = {
                    ...updatedData[index],
                    ISA_ASN_TRACK_NO: trackingNum,
                    TEMP_ISA_ASN_TRACK_NO: trackingNum,
                    trackingErrorMsg
                };
                this.setState({ gridLineItemData: updatedData });
                break;

            case "price":
                let priceVal = event.target.value;
                let dotCnt = priceVal.split('.').length - 1;
                const re = SDIConstants.POPriceRegex;

                if (!priceVal || (re.test(priceVal) && parseInt(priceVal) !== 0 && dotCnt < 2)) {

                    gridLineItemData[index] = {
                        ...gridLineItemData[index],
                        PRICE_PO: priceVal
                    };

                    if ((priceVal === gridLineItemData[index].TEMP_PRICE_PO) || !priceVal) {
                        gridLineItemData[index].PRICE_CHG_FLAG = "N";

                        gridLineItemData[index].ISSAVEDISABLE = (gridLineItemData[index].QTY_CHG_FLG && gridLineItemData[index].QTY_CHG_FLG === "Y" || gridLineItemData[index].DUE_CHG_FLAG && gridLineItemData[index].DUE_CHG_FLAG === "Y") ? false : true;
                    } else {
                        gridLineItemData[index].PRICE_CHG_FLAG = "Y";
                        gridLineItemData[index].ISSAVEDISABLE = false;
                    }

                    this.setState({
                        gridLineItemData,
                        gridLineIndex: index
                    });
                }
                break;

            case "poQty":
                const action = event.target?.value || event;
                const updatedItems = gridLineItemData.map((item, i) => {
                    if (i !== index) return item;

                    const currentQty = item.QTY_PO;
                    const receivedQty = item.QTY_RECV;
                    let newQty = currentQty;

                    const inputQty = Number(action);

                    if (!isNaN(inputQty)) {
                        if (inputQty === 0) {
                            newQty = currentQty;
                        } else if (receivedQty <= inputQty) {
                            newQty = inputQty;
                        }
                    } else if (action === "+") {
                        newQty = currentQty + 1;
                    } else if (action === "-") {
                        newQty = currentQty - 1;
                    }

                    const tempQtyPO = Number(item.TEMP_QTY_PO);
                    const changeFlag = newQty === tempQtyPO ? "N" : "Y";

                    const priceChangeFlag = item.PRICE_CHG_FLAG || "N";
                    const dueChangeFlag = item.DUE_CHG_FLAG || "N";

                    if (newQty === tempQtyPO && ((priceChangeFlag !== "Y") || (dueChangeFlag !== "Y"))) {
                        item.ISSAVEDISABLE = true;
                    } else {
                        item.ISSAVEDISABLE = false;
                    }

                    return {
                        ...item,
                        QTY_PO: newQty,
                        QTY_CHG_FLG: changeFlag
                    };
                });

                this.setState({
                    gridLineItemData: updatedItems,
                    gridLineIndex: index
                });

                break;

            case "asnQty":
                const actionAsnQty = event.target?.value || event;
                if (actionAsnQty === "+") {
                    updatedData[index].QTY_ASN += 1;
                    updatedData[index].isASNQtyChanged = "Y";
                } else if (actionAsnQty === "-") {
                    updatedData[index].QTY_ASN -= 1;
                    updatedData[index].isASNQtyChanged = updatedData[index].QTY_ASN === parseInt(updatedData[index].TEMP_QTY_ASN) ? "N" : "Y";
                } else if (!isNaN(Number(actionAsnQty))) {
                    updatedData[index].QTY_ASN = Math.min(updatedData[index].QTY_PO, Number(actionAsnQty));
                    updatedData[index].isASNQtyChanged = "Y";
                }
                this.setState({ gridLineItemData: updatedData, gridLineIndex: index });
                break;

            case "Reason":
           
            case "ReasonPC":
                updatedData[index] = {
                    ...updatedData[index],
                    [name === "Reason" ? 'SelectedReason' : 'SelectedPC']: event
                };
                this.setState({ gridLineItemData: updatedData });
                break;

            case "ReasonComments":
                updatedData[index] = {
                    ...updatedData[index],
                     'ReasonComments' : event.target.value
                };
                this.setState({ gridLineItemData: updatedData });
                break;

        }
    };

    checkSaveButtonState = (index, gridLineItemData) => {
        if (index === null) return false; // Early return if index is null

        const currentItem = gridLineItemData[index];
        const { TEMP_FREIGHT_PROVIDER, TEMP_ISA_ASN_TRACK_NO, TEMP_ASN_SHIP_DATE, isASNQtyChanged, PRICE_CHG_FLAG, QTY_CHG_FLG, DUE_CHG_FLAG } = currentItem;

        const isFreightSelected = !!TEMP_FREIGHT_PROVIDER;
        const isTrackingNumberFilled = !!(TEMP_ISA_ASN_TRACK_NO && TEMP_ISA_ASN_TRACK_NO.trim() !== '');
        const isAsnShipDateFilled = !!TEMP_ASN_SHIP_DATE;

        // Determine if the save button should be enabled
        if (isASNQtyChanged === "Y") {
            return isFreightSelected && isTrackingNumberFilled && isAsnShipDateFilled;
        }

        // If any of the change flags are set to "Y", enable the save button
        return (PRICE_CHG_FLAG === "Y" || QTY_CHG_FLG === "Y" || DUE_CHG_FLAG === "Y");
    };

    applyFilterClick = (PageNo, SortColumn, SortType, PO, businessUnitPO, isLineItem, isExportToExcel, isApplyFilter) => {
        const { selectedProblemCode, poNumber, selectedShipTo, selectedVendor, selectedInstallStore,
            workOrder, selectedWOstatus, selectedTechName, selectedInstallCustomer } = this.state;

        //Build problem code string if there are selected problem codes
        const problemCodeString = selectedProblemCode && selectedProblemCode.length > 0
            ? selectedProblemCode.map(selected => `'${selected.value}'`).join(', ')
            : '';

        // Set global variables if applying filters
        if (isApplyFilter === "Y") {
            shiptoglobVar = selectedShipTo.value;
            poglobVar = poNumber ? poNumber.trim() : "";
            vendorNameglobVar = selectedVendor.value;
            installStoreglobVar = selectedInstallStore.value;
            workOrderglobVar = workOrder;
            workOrderstatusglobVar = selectedWOstatus.value;
            techNameglobVar = selectedTechName.value;
            problemCodeglobVar = problemCodeString;
            installCustglobVar = selectedInstallCustomer.value;
        }

        // Prepare the grid load object
        const gridLoadBO = {
            businessUnit: CookieService.getLocalStorageValues("Session_SITEBU"),
            websiteID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            businessUnitPO,
            poID: PO === "" ? poglobVar : PO,
            shipTo: shiptoglobVar ? shiptoglobVar : "",
            vendorID: vendorNameglobVar ? vendorNameglobVar : "",
            techName: techNameglobVar ? techNameglobVar : "",
            installStore: installStoreglobVar ? installStoreglobVar : "",
            installCustomer: installCustglobVar ? installCustglobVar : "",
            workOrder: workOrderglobVar ? workOrderglobVar : "",
            workOrderStatus: workOrderstatusglobVar ? workOrderstatusglobVar : "",
            problemCode: problemCodeglobVar ? problemCodeglobVar : "",
            SortType,
            SortColumn,
            PageNo,
            isLineItem,
            isExportToExcel
        };

        // Show loader if not a line item
        if (isLineItem === "N") {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }

        // Handle export to Excel
        if (isExportToExcel === "Y") {
            POWorkbenchAction.poWorkbenchExcelAction(gridLoadBO);
            return true;
        }

        // Apply filters
        POWorkbenchAction.poWorkbenchApplyFilterAction(gridLoadBO);

        // Update state for pagination if not a line item
        if (isLineItem === "N") {
            this.setState({
                PageNo, SortType, SortColumn });
        }

        // Update state for filter application
        this.setState({
            isLineItem,
            problemCodeString: "",
            isapplyClick: true
        });
    };

    //WW-1167 Apply filter button response
    applyFilterClickResponse = () => {
        let response = JSON.parse(POWorkbenchStore.applyFilterClickResponse);
        let { errorDt } = response;
        let { t } = this.props;

        // Check for errors in the response
        if (errorDt[0].errorFlag.toUpperCase() !== "FALSE") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t('Technical issue please contact SDI help desk')
            });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return; // Early return on error
        }

        let { isLineItem } = this.state;
        let GridData = [];
        let gridLineItemData = [];
        let totalCount = 0;
        let pageCount = 0;

        if (isLineItem === "Y") {
            // Process line item data
                if (response.lineandAttachmentsDt && response.lineandAttachmentsDt.length > 0) {
                    gridLineItemData = response.lineandAttachmentsDt;
                    gridLineItemData = gridLineItemData.map(item => ({
                        ...item,
                        existAttach: [],
                        popUpAttach: [],
                        newAttach: [],
                        removeAttach: [],
                        attachmentErrormsg: "",
                        popUpOpen: false,
                        isASNQtyChanged: "",
                        isASNdisable: false,
                        SelectedReason: "",
                        SelectedPC: "",
                        ReasonComments: "",
                        QTY_CHG_FLG: "",
                        DUE_CHG_FLAG: "",
                        PRICE_CHG_FLAG: ""
                    }));

                    this.setState({ gridLineItemData });
                }
            }
        
         else {
            // Process grid data
            if (response.GridDataTbl && response.GridDataTbl.length > 0) {
                GridData = response.GridDataTbl;
            }

            if (response.GridCountTbl.length > 0) {
                totalCount = response.GridCountTbl[0].COUNT;
                pageCount = Math.ceil(totalCount / 10);
                this.setState({
                    GridData,
                    pageCount,
                    totalCount,
                    isLineItem: "N"
                });
            }
        }

        // Hide loader if not a line item
        if (isLineItem === "N") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    };

    onAccordianClick = (index) => {
        const { GridData, PageNo, SortColumn, SortType } = this.state;

        // Update GridData based on the clicked index
        const updatedGridData = GridData.map((item, i) => {
            const isAccordionClicked = i === index ? item.ISACCORDIANCLICKED === "FALSE" : "FALSE";

            if (i === index && isAccordionClicked === true) {
                // If the accordion is being opened, apply filters
                this.applyFilterClick(PageNo, SortColumn, SortType, item.PO_ID, item.BUSINESS_UNIT, "Y", "N", "N");
            }

            return {
                ...item,
                ISACCORDIANCLICKED: isAccordionClicked == true ? "TRUE" : "FALSE"
            };
        });

        // Update state with the new grid data and reset other states
        this.setState({
            GridData: updatedGridData,
            selectedIndex: index,
            gridLineItemData: [],
            gridLineIndex: null,
            cancelIndex: "",
            popupAttachment: [],
            isASNSubmit: "N"
        });
    };

    handlePagination = (e) => {
        let PageNo = e.selected + 1;
        this.applyFilterClick(PageNo, this.state.SortColumn, this.state.SortType, "", "", "N", "N", "N");
        this.setState({ PageNo });
    }

    handleDatePicker = (date, index, name) => {        
        const handledate = (date) => {
            if (date != null) {
                return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear())
            }
            return null;
        };

        let { GridData, gridLineItemData } = this.state;

        let val = date ? handledate(date) : "";

        switch (name) {
            case 'HeaderDueDate':
                GridData[index] = {
                    ...GridData[index],
                    DUE_DT: val,
                    isDueChange: !!date,
                    DUE_CHG_FLAG: date ? "Y" : "N"
                };

                if (gridLineItemData) {
                    gridLineItemData = gridLineItemData.map(item => ({
                        ...item,
                        DUE_DT: val,
                        ISSAVEDISABLE: false,
                        DUE_CHG_FLAG: date ? "Y" : "N"
                    }));
                }
                this.setState({ GridData, gridLineItemData, selectedIndex: index });
                break;

            case 'DueDate':
                gridLineItemData[index] = {
                    ...gridLineItemData[index],
                    DUE_DT: val,
                    isDueChange: !!date,
                    DUE_CHG_FLAG: date ? "Y" : "N",
                    ISSAVEDISABLE: false
                };

                this.setState({ gridLineItemData, gridLineIndex: index });
                break;

            case 'AsnDate':
                gridLineItemData[index] = {
                    ...gridLineItemData[index],
                    ASN_SHIP_DATE: val,
                    TEMP_ASN_SHIP_DATE: val,
                    ASN_CHG_FLAG: date ? "Y" : "N",
                };
                this.setState({ gridLineItemData, gridLineIndex: index });
                break;

            default:
                break;
        }
    }

    formatDateToMMDDYYYY = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    clearFields = (index) => {
        let gridLineItemData = this.state.gridLineItemData;
        gridLineItemData[index] = { ...gridLineItemData[index], SelectedReason: "", SelectedPC: "", ReasonComments: "" };
        this.setState({ gridLineItemData, isSubmitDisable: true })
        $('#CancelPopUp').modal('hide');
        $('#MoreDetailsPopUp').modal('hide');
    }

    handleSort = (event) => {
        const columns = document.querySelectorAll('.table-sort .sort-icon');
        const clickedColumn = event.currentTarget.querySelector('.sort-icon');
        columns.forEach(column => {
            if (column !== clickedColumn) {
                column.classList.remove('desc');
                column.classList.add('asc');
            }
        });

        let sortValue = "";
        let sortCoulumn = event.target.id;
        if (clickedColumn.classList.contains('asc')) {
            clickedColumn.classList.remove('asc');
            clickedColumn.classList.add('desc');
            sortValue = 'DESC';
        } else {
            clickedColumn.classList.remove('desc');
            clickedColumn.classList.add('asc');
            sortValue = 'ASC';
        }

        this.applyFilterClick(this.state.PageNo, sortCoulumn, sortValue, "", "", "N", "N", "N");
    }

    linelevelPopupDetails = (index, name, e, WOServiceUrl) => {
        const { GridData, gridLineItemData } = this.state;

        switch (name) {
            case "VENDOR": {
                const vendorDetails = {
                    VendorLoc: GridData[index].VENDOR_LOC,
                    Name: GridData[index].VENDOR_NAME,
                    Address1: GridData[index].ADDRESS1,
                    Address2: GridData[index].ADDRESS2,
                    City: GridData[index].CITY,
                    State: GridData[index].STATE,
                    Postal: GridData[index].POSTAL,
                    Phone: GridData[index].PHONE,
                };
                this.setState({ popupVendorDetail: vendorDetails });
                $('#VendorDetail').modal('show');
                break;
            }

            case "WO": {
                if (WOServiceUrl != "" && WOServiceUrl != undefined && WOServiceUrl != null) {
                    window.open(WOServiceUrl);
                    e.preventDefault();
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Technical issue. Please contact SDI customer care"
                    });
                }
                break;
            }

            case "ATTACHMENTS": {
                const updatedGridLineItemData = [...gridLineItemData];
                const currentItem = updatedGridLineItemData[index];
                const attachmentErrorMsg = "";

                // Initialize attachment arrays
                let attachmentPathArrLocal = currentItem.s_uploadedFilename ? currentItem.s_uploadedFilename.split("|") : [];
                let attachPath = currentItem.s_fileURL ? currentItem.s_fileURL.split("|") : [];
                let n_id = currentItem.n_id ? currentItem.n_id.split("|") : [];

                // Create file path array
                const filePathArray = attachmentPathArrLocal.map((filename, i) => {
                    if (filename) {
                        return {
                            FileName: filename,
                            FilePath: attachPath[i],
                            n_id: n_id[i]
                        };
                    }
                    return null;
                }).filter(Boolean); // Remove null values

                updatedGridLineItemData[index] = {
                    ...currentItem,
                    popUpAttach: currentItem.popUpOpen ? currentItem.popUpAttach : filePathArray,
                    existAttach: filePathArray,
                    popUpOpen: true,
                    attachmentErrormsg: attachmentErrorMsg
                };

                this.setState({
                    gridLineItemData: updatedGridLineItemData,
                    cancelIndex: index,
                    gridLineIndex: index
                });
                $('#attachmentPopup').modal('show');
                break;
            }

            case "CANCELATTACH": {
                const updatedGridLineItemData = [...gridLineItemData];
                const currentItem = updatedGridLineItemData[index];

                const filteredPopUpAttach = currentItem.popUpAttach.filter(val =>
                    !currentItem.newAttach.map(newVal => newVal.FilePath).includes(val.FilePath)
                );

                updatedGridLineItemData[index] = {
                    ...currentItem,
                    removeAttach: [],
                    popUpAttach: filteredPopUpAttach,
                    newAttach: [],
                    attachmentErrormsg: ""
                };

                this.setState({ gridLineItemData: updatedGridLineItemData });
                break;
            }

            case "SAVECLICK": {
                const updatedGridLineItemData = [...gridLineItemData];
                const currentItem = updatedGridLineItemData[index];

                const filteredPopUpAttach = currentItem.popUpAttach.filter(val =>
                    !currentItem.removeAttach.map(removeVal => removeVal.FilePath).includes(val.FilePath)
                );

                updatedGridLineItemData[index] = {
                    ...currentItem,
                    popUpAttach: filteredPopUpAttach,
                    removeAttach: [],
                    newAttach: []
                };

                this.setState({ gridLineItemData: updatedGridLineItemData, gridLineIndex: index });
                $('#attachmentPopup').modal('hide');
                break;
            }

            default:
                break;
        }
    }

    HistoryClick = (index, value) => {
        let { gridLineItemData } = this.state;
        let BO = {
            SelectedSIte: "WAL00",
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            PO_ID: gridLineItemData[index].PO_ID,
            LINE_NBR: gridLineItemData[index].LINE_NBR,
            SCHE_NBR: gridLineItemData[index].SCHED_NBR,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        POWorkbenchAction.poWorkbenchGetHistoryAction(BO);
    }

    cancelPOUpdate = (index) => {
        this.setState(prevState => {
            const updatedGridLineItemData = [...prevState.gridLineItemData];
            updatedGridLineItemData[index] = {
                ...updatedGridLineItemData[index],
                ISA_CANCEL_FLAG: "Y"
            };

            return { gridLineItemData: updatedGridLineItemData };
        }, () => {
            this.submitButtonClick(index);
            $('#CancelPopUp').modal('hide');
        });
    }

    submitButtonClick = (index) => {
        const { gridLineItemData } = this.state;
        const currentItem = gridLineItemData[index];

        const isFreightSelected = currentItem.TEMP_FREIGHT_PROVIDER;
        const isTrackingNumberFilled = currentItem.TEMP_ISA_ASN_TRACK_NO?.trim() !== '';
        const isAsnShipDateFilled = currentItem.TEMP_ASN_SHIP_DATE;
        const isASNQtyChanged = currentItem.isASNQtyChanged;

        // Determine if ASN should be submitted
        const isASNSubmit = isFreightSelected && isTrackingNumberFilled && isAsnShipDateFilled && isASNQtyChanged === "Y" ? "Y" : "N";

        // Update gridLineItemData
        const updatedGridLineItemData = [...gridLineItemData];
        updatedGridLineItemData[index] = {
            ...currentItem,
            isASNSubmit
        };

        this.setState({ gridLineItemData: updatedGridLineItemData });

        // Prepare save object
        const saveBO = {
            businessUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            websiteID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            businessUnitPO: currentItem.BUSINESS_UNIT,
            poNumber: currentItem.PO_ID,
            lineNumber: currentItem.LINE_NBR,
            schedNumber: currentItem.SCHED_NBR,
            vendorID: currentItem.VENDOR_ID,
            QTY_PO: currentItem.QTY_PO,
            AsnQty: currentItem.QTY_ASN - currentItem.TEMP_QTY_ASN,
            UNIT_OF_MEASURE: currentItem.UNIT_OF_MEASURE,
            PRICE_PO: currentItem.PRICE_PO,
            TrackingNumber: isASNSubmit === "Y" ? currentItem.ISA_ASN_TRACK_NO : null,
            ShipVia: isASNSubmit === "Y" ? currentItem.FREIGHT_PROVIDER : null,
            problemcode: currentItem.SelectedPC?.value,
            expdComments: currentItem.ReasonComments,
            duedate: this.formatDateToMMDDYYYY(currentItem.DUE_DT),
            shipTO: currentItem.SHIPTO_ID,
            AsnDate: isASNSubmit === "Y" ? this.formatDateToMMDDYYYY(currentItem.ASN_SHIP_DATE) : null,
            attachments: currentItem.ISA_CANCEL_FLAG ? [] : currentItem.popUpAttach.filter(val =>
                !currentItem.existAttach.map(val => val.FilePath).includes(val.FilePath)
            ),
            DUE_CHG_FLAG: currentItem.ISA_CANCEL_FLAG === "Y" ? "N" : currentItem.DUE_CHG_FLAG || "N",
            QTY_CHG_FLG: currentItem.ISA_CANCEL_FLAG === "Y" ? "N" : currentItem.QTY_CHG_FLG || "N",
            PRICE_CHG_FLAG: currentItem.ISA_CANCEL_FLAG === "Y" ? "N" : currentItem.PRICE_CHG_FLAG || "N",
            REASON_CD: currentItem.ISA_CANCEL_FLAG ? currentItem.SelectedReason.value : null,
            ISA_CANCEL_FLAG: currentItem.ISA_CANCEL_FLAG,
            removeAttachments: currentItem.ISA_CANCEL_FLAG ? [] : currentItem.existAttach.filter(val =>
                !currentItem.popUpAttach.map(val => val.FilePath).includes(val.FilePath)
            ),
            isASN: isASNSubmit,
            orderNumber: currentItem.ORDER_NO,
            workOrder: currentItem.ISA_WORK_ORDER_NO,
            INV_ITEM_ID: currentItem.INV_ITEM_ID,
            MFG_ITM_ID: currentItem.MFG_ITM_ID,
            vndItemID: currentItem.ITM_ID_VNDR,
            Descr254Mixed: currentItem.DESCRIPTION,
            CURRENCY_CD: currentItem.CURRENCY_CD,
            ERS_ACTION: currentItem.ERS_ACTION,
            DIST_CURRENCY: currentItem.DIST_CURRENCY,
            REQ_LINE_NBR: currentItem.REQ_LINE_NBR,
            PO_BU: currentItem.BUSINESS_UNIT,
            SITE_BU: currentItem.BUSINESS_UNIT,
            SHIP_CURRENCY: currentItem.CURRENCY_CD,
            CURRENCY_CD_BASE: currentItem.CURRENCY_CD_BASE,
            DIST_BASE_CURRENCY: currentItem.CURRENCY_CD_BASE,
            hQTYLNACCPT: currentItem.TEMP_QTY_ASN
        };

        // Show loader and hide modal
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        $('#MoreDetailsPopUp').modal('hide');

        // Call action to save data
        POWorkbenchAction.poWorkbenchSaveClickAction(saveBO);
    }

    saveButtonResponse = () => {
        const { t } = this.props;
        const response = JSON.parse(POWorkbenchStore.saveButtonResponse);
        const errorDt = response.errorDt;

        // Check for errors in the response
        if (errorDt[0].errorMessage.toUpperCase() !== "FALSE") {
            swal({
                allowOutsideClick: true,
                closeOnClickOutside: true,
                text: t('Technical issue please contact SDI help desk')
            });
          //  this.setState({ gridLineIndex: null });
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            return; // Early return on error
        }

        const resultDt = response.resultDt;
        $('#powork-success-popup').modal('show');

        // Determine the success message based on the result
        const resultMessage = resultDt[0].resultMessage.toUpperCase();
        let popupMessage;

        if (resultMessage === "CANCELLED SUCCESSFULLY") {
            popupMessage = "Your item has been cancelled successfully!";
        } else if (resultMessage.substring(0, 3) === "SUC") {
            popupMessage = "PO line details updated successfully!";
        } else {
            popupMessage = "Error occurred while updating";
        }

        this.setState({
            isSuccess: resultMessage === "CANCELLED SUCCESSFULLY" || resultMessage.substring(0, 3) === "SUC",
            popupMessage
        });

        this.setState({ gridLineIndex: null });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    saveButtonClick = (index) => {
        const { gridLineItemData } = this.state;
        const currentItem = gridLineItemData[index];

        const isFreightSelected = currentItem.FREIGHT_PROVIDER;
        const isTrackingNumberFilled = currentItem.ISA_ASN_TRACK_NO?.trim() !== '';
        const isAsnShipDateFilled = currentItem.ASN_SHIP_DATE;
        const isASNQtyChanged = currentItem.isASNQtyChanged;

        // Create a copy of the gridLineItemData
        const updatedGridLineItemData = [...gridLineItemData];

        // Determine if ASN should be submitted
        const isASNSubmit = isFreightSelected && isTrackingNumberFilled && isAsnShipDateFilled && isASNQtyChanged === "Y" ? "Y" : "N";

        // Update the item in the copied array
        updatedGridLineItemData[index] = {
            ...currentItem,
            isASNSubmit
        };

        // Update state with the new grid line item data
        this.setState({ gridLineItemData: updatedGridLineItemData, gridLineIndex: index });

        // Check conditions for submitting or showing the modal
        const shouldSubmit = isASNSubmit === "Y" &&
            (!currentItem.PRICE_CHG_FLAG || currentItem.PRICE_CHG_FLAG !== "Y") &&
            (!currentItem.QTY_CHG_FLG || currentItem.QTY_CHG_FLG !== "Y") &&
            (!currentItem.DUE_CHG_FLAG || currentItem.DUE_CHG_FLAG !== "Y");

        if (shouldSubmit) {
            this.submitButtonClick(index);
        } else {
            $('#MoreDetailsPopUp').modal('show');
        }
    }

    bindLineDetails = () => {
        const { t } = this.props;
        const { gridLineItemData, GridData, selectedIndex, LineFreightOptions, mindate } = this.state;

        return gridLineItemData.map((item, index) => {
            let { n_id, popUpAttach, DUE_DT, QTY_PO, QTY_ASN, isASNQtyChanged, ISA_ASN_TRACK_NO, ASN_SHIP_DATE, FREIGHT_PROVIDER } = item;

            // Determine attachment availability
            const isAttachAvailable = !!n_id || (popUpAttach?.length > 0);

            // Determine due date
            let dueDateValue = "";
            if (item.isDueChange) {
                dueDateValue = new Date(DUE_DT);
                item.DUE_DT = dueDateValue;
            } else if (GridData[selectedIndex]?.isDueChange) {
                dueDateValue = new Date(GridData[selectedIndex].DUE_DT);
                item.DUE_DT = dueDateValue;
                item.DUE_CHG_FLAG = "Y";
            } else {
                item.DUE_DT = "";
            }

            // Initialize tracking number and ASN ship date
            let trackingNumber = "";
            let asnShipDateValue = "";
            const freightProviders = LineFreightOptions.filter(option =>
                (QTY_PO === QTY_ASN && isASNQtyChanged && item.TEMP_FREIGHT_PROVIDER === option.value) ||
                (QTY_PO === QTY_ASN && (!isASNQtyChanged || (isASNQtyChanged == "N" && QTY_ASN == parseInt(item.TEMP_QTY_ASN))) && FREIGHT_PROVIDER === option.value) ||
                (QTY_PO < QTY_ASN && item.TEMP_FREIGHT_PROVIDER === option.value) ||
                (QTY_PO !== QTY_ASN && item.TEMP_FREIGHT_PROVIDER === option.value)
            ).map(option => ({ label: option.label, value: option.value }));

            // Set tracking number and ASN ship date based on conditions
            if (QTY_PO === QTY_ASN) {
                if (!isASNQtyChanged || (isASNQtyChanged == "N" && QTY_ASN == parseInt(item.TEMP_QTY_ASN))) {
                    item.isASNdisable = true;
                    trackingNumber = ISA_ASN_TRACK_NO;
                    asnShipDateValue = ASN_SHIP_DATE ? new Date(ASN_SHIP_DATE) : "";
                } else {
                    trackingNumber = item.TEMP_ISA_ASN_TRACK_NO || "";
                    asnShipDateValue = item.TEMP_ASN_SHIP_DATE ? new Date(item.TEMP_ASN_SHIP_DATE) : "";
                }
            }
            else if (QTY_PO < QTY_ASN) {
                isASNQtyChanged = "N"
                item.isASNdisable = true;
            }
            else {
                item.isASNdisable = false;              
                trackingNumber = item.TEMP_ISA_ASN_TRACK_NO || "";
                asnShipDateValue = item.TEMP_ASN_SHIP_DATE ? new Date(item.TEMP_ASN_SHIP_DATE) : "";
            }

            const shipMinDate = item.PO_DT ? new Date(item.PO_DT) : mindate;

            return (
                <tr key={index}>
                    <td colSpan={10} className="border-bottom p-0 accordian-body show border-top-POWOrk">
                        <div className="expedite-panel-item-details-container expedite-panel-container p-2 m-3">
                            <h6 className="form-label catalog-label w-100"><Trans>Item details</Trans></h6>
                            <div className="row">
                                {/* Item Details Section */}
                                <div className="col-lg-4 col-4 mb-sm-4 mb-4 item-details-section custom-row-1">
                                    <table className="w-100">
                                        <tbody>
                                            {[
                                                { label: "Line #", value: item.LINE_NBR },
                                                { label: "Item ID", value: item.INV_ITEM_ID },
                                                { label: "Description", value: item.DESCRIPTION },
                                                { label: "MFG part #", value: item.MFG_ID },
                                                { label: "MFG ID", value: item.MFG_ITM_ID }
                                            ].map((detail, idx) => (
                                                <tr key={idx}>
                                                    <td className="border-0 form-lable-section popover-item-cost align-baseline pr-2"><Trans>{detail.label}</Trans>:</td>
                                                    <td className="border-0 item-details-sub-value  text-wrap">{detail.value && String(detail.value).trim() !== "" ? detail.value : "-" }</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* PO Quantity Section */}
                                <div className="col-lg-4 col-4 mb-sm-4 mb-4 item-details-section">
                                    <table className="w-100">
                                        <tbody>
                                            <tr>
                                                <td className="border-0 form-lable-section popover-item-cost"><Trans>PO qty</Trans>:</td>
                                                <td className="border-0 item-details-sub-value">
                                                    <div className="custom-product-add-cart justify-content-start p-0 m-0">
                                                        <form id="myform" method="POST" className="quantity" action="#">
                                                            <input type="button" defaultValue="-" className="qtyminus minus" field="quantity" disabled={QTY_PO <= item.QTY_RECV || QTY_PO <= 1} onClick={() => this.onChangeField("poQty", "-", index)} />
                                                            <input type="text" name="quantity" className="qty" min={item.QTY_RECV === 0 ? QTY_PO === 1 : item.QTY_RECV} value={QTY_PO} id={`Quantity${item.LINE_NBR}`} maxLength="5" size="5" onChange={(e) => this.onChangeField("poQty", e, index)} />
                                                            <input type="button" defaultValue="+" className="qtyplus plus" field="quantity" disabled={item.QTY_RECV === 99999 ? item.QTY_RECV : QTY_PO >= 99999} onClick={() => this.onChangeField("poQty", "+", index)} />
                                                        </form>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="border-0 form-lable-section popover-item-cost"><Trans>Open qty</Trans>:</td>
                                                <td className="border-0 item-details-sub-value">{item.QTY_OPEN || "-"}</td>
                                            </tr>
                                            <tr>
                                            <td className="border-0 form-lable-section popover-item-cost"><Trans>ASN qty</Trans>:</td>

                                            <td className="border-0 item-details-sub-value">
                                                <div className="custom-product-add-cart justify-content-start p-0 m-0">
                                                    <form id="myform" method="POST" className="quantity" action="#">
                                                        <input type="button" defaultValue="-" className="qtyminus minus"
                                                            field="quantity"
                                                            disabled={item.QTY_ASN <= item.TEMP_QTY_ASN || item.isASNdisable}
                                                            onClick={(e) => { this.onChangeField("asnQty", "-", index) }} />

                                                        <input type="text" name="quantity" defaultValue={0}
                                                            className="qty" min={(item.QTY_ASN + 1)}
                                                            id={`Quantity${item.LINE_NBR}`}

                                                            value={item.QTY_ASN}
                                                            maxLength="5"
                                                            size="5"
                                                            disabled={item.isASNdisable}
                                                            onChange={(e) => { this.onChangeField("asnQty", e, index) }} />

                                                        <input type="button" defaultValue="+" className="qtyplus plus"
                                                            field="quantity"
                                                            disabled={item.QTY_ASN == 99999 || item.QTY_ASN >= item.QTY_PO || item.isASNdisable}
                                                            onClick={(e) => { this.onChangeField("asnQty", "+", index) }} />
                                                    </form>
                                                </div>
                                                </td>  
                                            </tr>

                                            <tr>
                                                <td className="border-0 form-lable-section popover-item-cost"><Trans>Invoiced qty</Trans>:</td>
                                                <td className="border-0 item-details-sub-value">{item.QTY_INVOICED || "-"}</td>
                                            </tr>
                                            <tr>
                                                <td className="border-0 form-lable-section popover-item-cost"><Trans>Unit price ($)</Trans>:</td>
                                                <td className="border-0 item-details-sub-value">
                                                    <input type="text" name="unitPrice" className="unit-price-input po-work-unit-price" value={item.PRICE_PO} onChange={(e) => this.onChangeField("price", e, index)} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Additional Details Section */}
                                <div className="col-lg-4 col-4 mb-md-4 mb-sm-4 md-4">
                                    <table className="w-100">
                                        <tbody>
                                            {[
                                                { label: "REQ ID", value: item.ORDER_NO },
                                                { label: "WO status", value: item.WO_STATUS },
                                                { label: "Unit of measure", value: item.UNIT_OF_MEASURE },
                                            ].map((detail, idx) => (
                                                <tr key={idx}>
                                                    <td className="border-0 form-lable-section popover-item-cost"><Trans>{detail.label}</Trans>:</td>
                                                    <td className="border-0 item-details-sub-value">{detail.value || "-"}</td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td className="border-0 form-lable-section popover-item-cost"><Trans>History</Trans>:</td>
                                                    <td className="border-0">
                                                        <span className="item-vlaue">
                                                            <a href="#" data-toggle="modal" data-backdrop="static" data-keyboard="false" onClick={() => this.HistoryClick(index, item)}>
                                                                <img src="images/time-loading-icon.svg" />
                                                            </a>
                                                        </span>
                                                    </td>                                               
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Form Section */}
                            <div className="row mt-sm-0 mt-3">
                                {/* Freight Provider */}
                                <div className="col-3 mb-3 mt-3">
                                    <label className="form-label catalog-label-secondary"><Trans>Freight provider</Trans></label>
                                    {isASNQtyChanged === "Y" && (QTY_ASN !== parseInt(item.TEMP_QTY_ASN)) ? <span className="slash ml-1">*</span> : null}
                                    <Select
                                        options={LineFreightOptions}
                                        value={freightProviders}
                                        isDisabled={item.isASNdisable && isASNQtyChanged !== "Y"}
                                        onChange={(e) => this.onChangeField("SelectedLineFreight", e, index)}
                                        name="FreightProvider"
                                    />
                                </div>

                                {/* Tracking Number */}
                                <div className="col-3 mb-3 mt-3">
                                    <label className="form-label catalog-label-secondary"><Trans>Tracking #</Trans></label>
                                    {isASNQtyChanged === "Y" && (QTY_ASN !== parseInt(item.TEMP_QTY_ASN)) ? <span className="slash ml-1">*</span> : null}
                                    <input
                                        type="text"
                                        maxLength="25"
                                        className={`form-control ${item.isASNdisable && isASNQtyChanged !== "Y" ? "common-disabled" : ""}`}
                                        id={`tracking-no-${index}`}
                                        placeholder={t("Enter tracking no")}
                                        value={trackingNumber}
                                        onChange={(e) => this.onChangeField("TrackingNumber", e, index)}
                                        disabled={item.isASNdisable && isASNQtyChanged !== "Y"}
                                    />
                                    {item.trackingErrorMsg && (
                                        <p className="font-14 font-regular color-validation"><Trans>{item.trackingErrorMsg}</Trans></p>
                                    )}
                                </div>

                                {/* ASN Ship Date */}
                                <div className="col-3 mb-3 mt-3">
                                    <label className="form-label form-label catalog-label-secondary" htmlFor={`asn-shipdate-${index}`}><Trans>ASN ship date</Trans></label>
                                    {isASNQtyChanged === "Y" && (QTY_ASN !== parseInt(item.TEMP_QTY_ASN)) ? <span className="slash ml-1">*</span> : null}
                                    <DatePicker
                                        className={`form-control datepicker w-100 form-input-section ${item.isASNdisable && isASNQtyChanged !== "Y" ? "common-disabled" : ""}`}
                                        id={`AsnDate-${index}`}
                                        fixedHeight
                                        placeholderText="MM/DD/YYYY"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        selected={asnShipDateValue}
                                        disabled={item.isASNdisable && isASNQtyChanged !== "Y"}
                                        minDate={shipMinDate}
                                        onChange={(e) => this.handleDatePicker(e, index, "AsnDate")}
                                    />
                                    <span className="calendar-icon filter-calendar-icon calender-style-POWork mb-22" onClick={() => $(`#AsnDate-${index}`).focus()}></span>
                                </div>

                                {/* PO Due Date */}
                                <div className="col-3 mb-3 mt-3">
                                    <label className="form-label form-label catalog-label-secondary"><Trans>PO due date</Trans></label>
                                    <DatePicker
                                        className={`form-control datepicker w-100 form-input-section`}
                                        id={`LineDueDate-${index}`}
                                        fixedHeight
                                        placeholderText="MM/DD/YYYY"
                                        dateFormat="MM/dd/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        selected={dueDateValue}
                                        minDate={mindate}
                                        onChange={(e) => this.handleDatePicker(e, index, "DueDate")}
                                    />
                                    <span className="calendar-icon filter-calendar-icon calender-style-POWork mb-22" onClick={() => $(`#LineDueDate-${index}`).focus()}></span>
                                </div>

                                {/* Attachments */}
                                <div className="col-3 mb-3 mt-3">
                                    <label className="form-label form-label catalog-label-secondary"><Trans>Add attachments  </Trans>
                                        <a className="expedite-input-info-tooltip">
                                            <img src="images/info-icon-sdi.svg" alt="info" />
                                            <span className="expedite-input-info-tooltiptext"><Trans>Previously uploaded attachments cannot be removed, and the remove option is unavailable.</Trans></span>
                                        </a>
                                    </label>

                                    {!isAttachAvailable ? (
                                        <div className="position-relative upload-field">
                                            <span><img src="images/vendor-image-upload.svg" alt="upload-logo" /><Trans>Upload</Trans></span>
                                            <input
                                                className="form-control opacity"
                                                type="button"
                                                id={`formFile-${index}`}
                                                onClick={() => this.linelevelPopupDetails(index, "ATTACHMENTS", "", "")}
                                            />
                                        </div>
                                    ) : (
                                        <div className="position-relative upload-field after-upload-field">
                                                <span>
                                                    <img className="mr-1" src="images/file-icon.svg" alt="upload-logo" style={{ "width": "25px" }} />
                                                    <span className="po-work-files-font"><Trans>Files</Trans></span>
                                                </span>
                                            <button
                                                className="btn custom-btn-primary px-3 py-1 m-0 font-12"
                                                onClick={() => this.linelevelPopupDetails(index, "ATTACHMENTS", "", "")}
                                            >
                                                <Trans>View</Trans>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Action Buttons */}
                            <div className="mt-4 pt-2 d-flex justify-content-end">
                                {item.ISA_CAN_CANCEL_FLAG === "Y" && (
                                    <button
                                        className="btn btn-secondary py-2 px-4 custom-btn-secondary secondary-btn float-left mr-3"
                                        data-toggle="modal"
                                        data-target="#CancelPopUp"
                                        onClick={() => this.setState({ cancelindex: index })}
                                    >
                                        <Trans>Cancel item</Trans>
                                    </button>
                                )}
                                <button
                                    className="btn custom-btn-secondary-inc secondary-btn px-4 mr-3"
                                    type="button"
                                    onClick={() => this.incidentClick(item)}
                                >
                                    <Trans>Incident</Trans>
                                </button>
                                <button
                                    className="btn custom-btn-primary px-4"
                                    type="button"
                                    disabled={!this.checkSaveButtonState(index, gridLineItemData) || item.trackingErrorMsg}
                                    onClick={() => this.saveButtonClick(index)}
                                >
                                    <Trans>Save</Trans>
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        });
    }

    incidentClick = (value) => {
        let customFields = []
        customFields.push({
            customFieldName: "order_number",
            customFieldValue: value.ORDER_NO
        })
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            PassWord: "",
            OrderNumber: value.ORDER_NO,
            PONumber: value.PO_ID,
            HomepageRequest: false,
            customFields: customFields,
            WorkOrder: value.ISA_WORK_ORDER_NO,
            isFromPO: "true"
        };

        OrderStatusAction.getPassThroughAutheURl(PassAutheBO);
    }

    /**
* WW-1167_Nandhini L
* Invoke this method for the Incident click Response
* */
    incidentClickResponse = () => {
        let URl = JSON.parse(OrderStatusStore.PassThroughAuthe)
        window.open(URl);
        window.preventDefault();
    }

    HistoryClickResponse = () => {
        let Response = JSON.parse(POWorkbenchStore.HistoryDataResponse);
        let history = []
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        if (Response.History.length != 0 && Response.History != null && Response.History != undefined) {
            if (Response.History.length > 0) {
                history = Response.History
            }
            $('#HistoryPopup').modal('show');
            this.setState({ historyData: history, isexport: false });
        }
        else {

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "No Records Found"
            });
        }

    }

    /**
* WW-1167_Nandhini L
* Invoke this method on the adding attachments.
* */
    handleAttachment = (event) => {
        let files = event.target.files;
        let { gridLineItemData } = this.state;
        let updatedgridLineItemData = [...gridLineItemData];
        let attachmentErrormsg = "";
        let Attachments = updatedgridLineItemData[this.state.gridLineIndex].popUpAttach;
        let RemoveAttachments = updatedgridLineItemData[this.state.gridLineIndex].removeAttach;
        let filesvalue = []
        let isRemoved = false;
        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                let filetype = files[i]?.type.toLowerCase();
                let filename = files[i].name.trim();
                let validTypes = ['jpg', 'jpeg', 'png', 'pdf'];

                if (!validTypes.some(type => filetype.includes(type))) {
                    attachmentErrormsg = "You can choose only the image (jpg, jpeg, png) and PDF files";
                } else if (Attachments.length > 0) {

                    let isDuplicate = Attachments.some(attach => attach.FileName.trim() === filename);
                    isRemoved = RemoveAttachments.some(attach => attach.FileName.trim() === filename);

                    if (isRemoved) {
                        RemoveAttachments = RemoveAttachments.filter(attach => attach.FileName.trim() !== filename);
                        updatedgridLineItemData[this.state.gridLineIndex] = {
                            ...updatedgridLineItemData[this.state.gridLineIndex],
                            removeAttach: RemoveAttachments
                        };
                        this.setState({ gridLineItemData: updatedgridLineItemData });
                        $("#attachment").val('');
                        return;
                    }

                    if (isDuplicate) {
                        attachmentErrormsg = "Selected file is already attached. Please upload another file.";
                    }
                }

                if (attachmentErrormsg) {
                    updatedgridLineItemData[this.state.gridLineIndex] = {
                        ...updatedgridLineItemData[this.state.gridLineIndex],
                        attachmentErrormsg: attachmentErrormsg
                    };

                    this.setState({ gridLineItemData: updatedgridLineItemData });
                    $("#attachment").val('');
                    return;
                }

                filesvalue.push(files[i]);
            }
            let filepathlength = ""
            if (Attachments) {
                for (let i = 0; i < Attachments.length; i++) {
                    filepathlength = filepathlength + Attachments[i].FileName + "|"
                }
            }
            if (filesvalue) {
                for (let k = 0; k < filesvalue.length; k++) {
                    filepathlength = filepathlength + filesvalue[k].name + "|"
                }
            }
            let lengthvalidate = filepathlength.length > 254 ? 1 : 0
            if (lengthvalidate == 1) {
                attachmentErrormsg = "File name exceeds limit. Please shorten or remove some files.";
                updatedgridLineItemData[this.state.gridLineIndex] = {
                    ...updatedgridLineItemData[this.state.gridLineIndex],
                    attachmentErrormsg: attachmentErrormsg
                };

                this.setState({ gridLineItemData: updatedgridLineItemData })
                $("#attachment").val('');
                return;
            } else {
                if (filesvalue) {
                    if (filesvalue.length > 0) {
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        NonCatalogAction.addAttachment(filesvalue);
                    }
                }

                updatedgridLineItemData[this.state.gridLineIndex] = {
                    ...updatedgridLineItemData[this.state.gridLineIndex], attachmentErrormsg: attachmentErrormsg
                };

                this.setState({ gridLineItemData: updatedgridLineItemData })
                $("#attachment").val('');
            }
        }
    }

    /**
* WW-1167_Nandhini L
* Invoke this method for attachment add response in temp file
* */
    attachmentResponse = () => {
        $("#attachment").val('');
        const attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
        let { gridLineItemData } = this.state;
        let updatedgridLineItemData = [...gridLineItemData];
        let tempAttachments = updatedgridLineItemData[this.state.gridLineIndex].popUpAttach;
        let newAttachments = updatedgridLineItemData[this.state.gridLineIndex].newAttach;
        //let tempAttachments = this.state.popupAttachment;

        if (tempAttachments !== null) {
            tempAttachments = tempAttachments.concat(attachmentResponse);
        } else {
            tempAttachments = attachmentResponse;
        }
        if (newAttachments !== null) {
            newAttachments = newAttachments.concat(attachmentResponse);
        } else {
            newAttachments = attachmentResponse;
        }
        updatedgridLineItemData[this.state.gridLineIndex] = {
            ...updatedgridLineItemData[this.state.gridLineIndex], popUpAttach: tempAttachments, newAttach: newAttachments,

        };


        this.setState({ gridLineItemData: updatedgridLineItemData });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    };

    /**
* WW-1167_Nandhini L
* Invoke this method on the click of download attachments
* */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };

    /**
* WW-1167_Nandhini L
* Invoke this method on the click of remove icon in attachments popup
* */
    removeCartAttachments = (e, index, attachment) => {
        let gridLineItemData = this.state.gridLineItemData;
        let newAttach = gridLineItemData[this.state.gridLineIndex].newAttach;
        let popupAttachOrig = gridLineItemData[this.state.gridLineIndex].popUpAttach;
        let removeAttach = gridLineItemData[this.state.gridLineIndex].removeAttach;
        removeAttach.push(attachment);

        if (newAttach.length > 0) {
            let popUpAttach = newAttach.filter(x => x.FileName.includes(attachment.FileName));

            // Remove popupAttach items from popupAttachOrig
            popupAttachOrig = popupAttachOrig.filter(origAttach =>
                !popUpAttach.some(popupAttachItem => popupAttachItem.FileName === origAttach.FileName)
            );

        }

        gridLineItemData[this.state.gridLineIndex] = {
            ...gridLineItemData[this.state.gridLineIndex],
            removeAttach: removeAttach, attachmentErrormsg: "",
            popUpAttach: popupAttachOrig
        };
        this.setState({ gridLineItemData: gridLineItemData });
    }

    /**
* WW-1167_Nandhini L
* Invoke this method on the binding of attachments
* */
    bindAttachments = () => {

        let gridLineData = this.state.gridLineItemData[this.state.gridLineIndex];

        const attachmentData = gridLineData ? gridLineData.popUpAttach : []
        if (attachmentData !== null && attachmentData !== undefined) {
            if (attachmentData.length > 0) {
                return attachmentData.map((attachment, index) => {

                    let filep = attachment.FilePath
                    filep = filep.replace(":80", "")
                    filep = filep.replace("http", "https")
                    let truncatedFileName = attachment.FileName.length > 30
                        ? `${attachment.FileName.substring(0, 30)}...`
                        : attachment.FileName;



                    //<p Container(1323894574893023894).png
                    //<button className="border-0 p-0 bg-transparent"><img className="ml-2" src="images/cancel-icon.svg" alt="" /></button></p >
                    if (!gridLineData.removeAttach.map(val => val.FilePath).includes(attachment.FilePath)) {
                        return (
                            <div >
                                <p>
                                    <a href="#" className="cancel-file-section my-2"
                                        title={attachment.FileName} data-toggle="tooltip"
                                        onClick={(e) => this.downloadAttachment(e, attachment)}
                                    >
                                        {truncatedFileName}
                                    </a>
                                    {filep.includes("C:\\temp\\") ?
                                        <button className="border-0 p-0 bg-transparent">
                                            <img className="ml-2" src="Images/cancel-icon-red.svg" alt="" onClick={(e) => this.removeCartAttachments(e, index, attachment)} />
                                        </button>
                                    : null}
                                </p>
                            </div>
                        );
                    }
                });
            }
        }
        return null;
    };

    /**
* WW-1167_Nandhini L
* Invoke this method on the bind of history
* */
    bindHistory = () => {
        return this.state.historyData.map((value, index) => {
            return (
                <tr>
                    <td>{value.COMDATE}</td>
                    <td>{value.NOTES_1000}</td>
                    <td>{value.PROBDESC}</td>
                    <td>{value.ISA_EMPLOYEE_NAME}</td>
                </tr>
            )
        })
    }

    /**
* WW-1167_Nandhini L
* Invoke this method on the bind of Cancel popup
* */

    bindCancelPopup = () => {
        const { t } = this.props;
        let lineindex = this.state.cancelindex;
        return this.state.gridLineItemData.map((value, index) => {
            if (index == lineindex) {
                return (
                    <React.Fragment key={lineindex}>

                        <div className="row mb-4 mt-2 documents-section">
                            <div className="col-md-6 mb-3">
                                <label className="form-label catalog-label w-100 mandatory-after" htmlFor="Reason"><Trans>Reason</Trans></label>

                                <Select className="w-100"
                                    options={this.state.LineReasonOptions}
                                    value={value.SelectedReason}
                                    onChange={(e) => this.onChangeField("Reason", e, lineindex)}
                                    name='REASON'
                                    id='ReasonDD'
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label catalog-label w-100 mandatory-after" htmlFor="Problem"><Trans>Problem code</Trans></label>
                                <Select className="w-100"
                                    options={this.state.ProblemCodeOptions}
                                    value={value.SelectedPC}
                                    onChange={(e) => this.onChangeField("ReasonPC", e, lineindex)}
                                    name='PROBLEMCODE'
                                    id='ProblemDD'

                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label catalog-label w-100 mandatory-after" htmlFor="Comments"><Trans>Comments</Trans></label>
                                <textarea className="w-100 comments-POWork" type="text-area" rows={4} maxLength="254" placeholder={t("Enter comments")} value={value.ReasonComments} onChange={(e) => this.onChangeField("ReasonComments", e, lineindex)} ></textarea>
                            </div>
                            <div className="w-100 d-flex justify-content-end mt-3 pr-3">

                                <button className="btn custom-btn-secondary-Cancel secondary-btn px-4 mr-3 primary-btn-responsive" onClick={() => this.clearFields(lineindex)} ><Trans>Cancel</Trans></button>

                                <button className="btn custom-btn-primary px-4 m-0 primary-btn-responsive" disabled={!(this.state.gridLineItemData[lineindex].SelectedReason && this.state.gridLineItemData[lineindex].SelectedPC && this.state.gridLineItemData[lineindex].ReasonComments)} onClick={() => this.cancelPOUpdate(lineindex)}><Trans>Submit</Trans></button>
                            </div>
                        </div>


                    </React.Fragment>

                );
            }


        }
        )
    }

    /**
* WW-1167_Nandhini L
* Invoke this method on the bind of More details popup
* */
    bindMoreDetailsPopup = () => {
        const { t } = this.props;
        const lineindex = this.state.gridLineIndex;

        if (lineindex === null || lineindex === undefined || lineindex < 0 ) {
            return null;
        }

        const value = this.state.gridLineItemData[lineindex];

        return (
            <React.Fragment key={lineindex}>
                <div className="row mb-4 mt-2 documents-section">
                    <div className="col-md-12 mb-3">
                        <label className="form-label catalog-label w-100 mandatory-after" htmlFor="Problem"><Trans>Problem code</Trans></label>
                        <Select className="w-100"
                            options={this.state.ProblemCodeOptions.filter(option => option.label !== "Cancel PO")}
                            value={value.SelectedPC}
                            onChange={(e) => this.onChangeField("ReasonPC", e, lineindex)}
                            name='PROBLEMCODE'
                            id='ProblemDD'
                        />
                    </div>
                    <div className="col-md-12 mb-3">
                        <label className="form-label catalog-label w-100 mandatory-after" htmlFor="Comments"><Trans>Comments</Trans></label>
                        <textarea className="w-100 comments-POWork" type="text-area" rows={4} maxLength="254" placeholder={t("Enter comments")} value={value.ReasonComments} onChange={(e) => this.onChangeField("ReasonComments", e, lineindex)} ></textarea>
                    </div>
                    <div className="w-100 d-flex justify-content-end mt-3 pr-3">
                        <button className="btn custom-btn-secondary-Cancel secondary-btn px-4 mr-3 primary-btn-responsive" onClick={() => this.clearFields(lineindex)} ><Trans>Cancel</Trans></button>
                        <button className="btn custom-btn-primary px-4 m-0 primary-btn-responsive" disabled={!(value.SelectedPC && value.ReasonComments)} onClick={() => this.submitButtonClick(lineindex)}><Trans>Submit</Trans></button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    /**
   * WW-1167_Nandhini L
   * This method invokes on binding grid data
   * */
    bindGridData = () => {
        const { t } = this.props;
        if (this.state.GridData.length > 0) {
            return this.state.GridData.map((value, index) => {

                let dateValue;
                if (value.DUE_DT != undefined && value.DUE_DT != null && value.DUE_DT != "") {
                    dateValue = new Date(value.DUE_DT);
                }
                else {
                    dateValue = "";
                }

                return (
                    <React.Fragment key={index}>
                        <tr style={{ "border-bottom": "1px solid #dee2e6" }}>

                            <td data-toggle="collapse" data-target="#order-row-1" className={`accordion-toggle ${value.ISACCORDIANCLICKED === "FALSE" ? 'collapsed' : ''}`}><span className="accordion-arrow accordion-arrow-change" onClick={() => { this.onAccordianClick(index) }} /></td>

                            <td> <a href="#" className="table-vendorname" data-toggle="modal" data-backdrop="static" data-keyboard="false" onClick={e => this.linelevelPopupDetails(index, "VENDOR")} >{value.VENDOR_NAME}</a></td>
                            <td> <a href="#" onClick={(e) => this.linelevelPopupDetails(index, "WO", e, value.TOKEN)} >{value.ISA_WORK_ORDER_NO}</a></td>

                            <td>{value.PO_DT}</td>
                            <td >{value.PO_ID}</td>
                            <td >{value.SHIPTO_ID}</td>
                            <td >{value.ISA_EMPLOYEE_ID}</td>
                            <td >{value.WO_PRIORITY}</td>
                            <td >{value.LINE_FIELD_C6}</td>

                            <td className="position-relative">
                                <div className="position-relative">
                                    <div>
                                <DatePicker className="form-control datepicker w-100 form-input-section"
                                    id={`DueDate-${index}`}
                                    fixedHeight
                                    placeholderText="MM/DD/YYYY"
                                    dateFormat="MM/dd/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    selected={dateValue}
                                    minDate={this.state.mindate}
                                    onChange={(e) => this.handleDatePicker(e, index, "HeaderDueDate")}
                                        />
                                </div>
                                <span className="calendar-icon filter-calendar-icon  calender-style-POwork form-calendar-icon mb-1" onClick={() => $(`#DueDate-${index}`).focus()} />
                                </div>
                            </td>

                        </tr>




                        {value.ISACCORDIANCLICKED === "TRUE" ? (
                            this.state.gridLineItemData.length > 0 ? (
                                this.bindLineDetails(value.PO_ID, index)
                            ) : (
                                <tr>
                                    <td colSpan={10}>
                                        <div style={{ display: "flex", justifyContent: "center" }} id="RotatingLinesId">
                                            <RotatingLines
                                                strokeColor="#fcb913"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="50"
                                                visible={true}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            )
                        ) : null}


                    </React.Fragment>


                );

            })
        }
    }


    render() {
        const { t } = this.props;
        return (
            <>
                <title><Trans>PO Workbench</Trans></title>
                <div className="content-section">
                    <div className="container-fluid Expedite-PO">
                        <div className="row p-1">
                            {/*Page Heading starts here*/}
                            {/* <div className="justify-content-center row px-4">*/}
                            <div className="col-md-12 page-heading">
                                <h5 className="page-title"><Trans>PO Workbench</Trans></h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-OrdStatus">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                            {/*Page Heading ends here*/}

                            {/* Form Fields section starts Here */}
                            <div className="col-md-12 mt-2">
                                <p className="description-color mt-3 font-15">
                                    <img className="mr-2 info-icon-style mb-1" src="images/PO-Info.svg" />
                                    <Trans>Select or enter at least one of the following</Trans> (<span className="slash">*</span>) <Trans>fields</Trans>: <Trans>Ship to location, PO number, Vendor name, Install store and Work order to filter down your records.</Trans>
                                </p>
                                <div className="row justify-content-start">
                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100"><Trans>Ship to location</Trans><span className="slash ml-1">*</span></label>

                                        <Select id="shipToDD"
                                            options={this.state.ShipToLocationOptions}
                                            value={this.state.selectedShipTo}
                                            className="DropDown-Font-Size"
                                            onChange={(e) => {
                                                if (e.value === "") {
                                                    this.setState({ selectedShipTo: "" });
                                                } else {
                                                    this.setState({ selectedShipTo: e });
                                                }
                                            }}

                                            name="SHIPTO"
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100" htmlFor="po-number"><Trans>PO number</Trans><span className="slash ml-1">*</span></label>
                                        <input type="text" className="form-control" id="po-number" placeholder={t("Enter PO number")} value={this.state.poNumber} maxlength="10" onChange={e => this.onChangeField("PONumber", e, "")} />                                        
                                    </div>


                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100"><Trans>Vendor name</Trans><span className="slash ml-1">*</span></label>

                                        <Select id="vendorDD"
                                            options={this.state.VendorNameOptions}
                                            value={this.state.selectedVendor}
                                            className="PO-Work-DropDown-Font-Size"
                                            onChange={(e) => {
                                                if (e.value === "") {
                                                    this.setState({ selectedVendor: "" });
                                                } else {
                                                    this.setState({ selectedVendor: e });
                                                }
                                            }}
                                            name="VENDORNAME"
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100"><Trans>Install store</Trans><span className="slash ml-1">*</span></label>
                                        <Select id="installStoreDD"
                                            options={this.state.InstallStoreOptions}
                                            value={this.state.selectedInstallStore}
                                            className="PO-Work-DropDown-Font-Size"
                                            onChange={(e) => {
                                                if (e.value === "") {
                                                    this.setState({ selectedInstallStore: "" });
                                                } else {
                                                    this.setState({ selectedInstallStore: e });
                                                }
                                            }}
                                            name="INSTALLSTORE"
                                        />
                                    </div>

                                    <div className="col-lg-3 col-md-4 w-100">
                                        <label className="form-label catalog-label w-100" htmlFor="work-order"><Trans>Work order</Trans><span className="slash ml-1">*</span></label>
                                        <input type="text" className="form-control" id="work-order" placeholder={t("Enter work order")} value={this.state.workOrder} maxlength="10" onChange={e => this.onChangeField("WOOrder", e, "")} />
                                        {this.state.workOrder != "" ?
                                            < span className="mstk-cancel-header cursor-pointer" style={{ "margin-right": "-25px", "z-index": "auto" }} onClick={() => this.setState({ workOrder: "" })} > </span> : null}
                                    </div>


                                    {this.state.isWOStatusDDVisible == true && this.state.workOrder != "" ?
                                        <div className="col-lg-3 col-md-4 mb-4 w-100">
                                            <label className="form-label catalog-label w-100"><Trans>WO status</Trans></label>
                                            <Select id="woStatusDD"
                                                options={this.state.WOStatusOptions}
                                                value={this.state.selectedWOstatus}
                                                className="PO-Work-DropDown-Font-Size"
                                                onChange={(e) => {
                                                    if (e.value === "") {
                                                        this.setState({ selectedWOstatus: "" });
                                                    } else {
                                                        this.setState({ selectedWOstatus: e });
                                                    }
                                                }}
                                                name="WOSTATUS"
                                            />
                                        </div> : null}


                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100"><Trans>Tech name</Trans></label>
                                        <Select id="techNameDD"
                                            options={this.state.TechNameOptions}
                                            value={this.state.selectedTechName}
                                            className="PO-Work-DropDown-Font-Size"
                                            onChange={(e) => {
                                                if (e.value === "") {
                                                    this.setState({ selectedTechName: "" });
                                                } else {
                                                    this.setState({ selectedTechName: e });
                                                }
                                            }}
                                            name="TECHNAME"
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-4 mb-4 w-100 PC-MultiSelect">
                                        <label className="form-label catalog-label w-100"><Trans>Problem codes</Trans></label>
                                        <MultiSelect
                                            options={this.state.ProblemCodeOptions}
                                            style={{ "marginTop": "30px" }}
                                            className="DropDown-Font-Size UserCSS w-100"
                                            id="problemCodeDD"
                                            value={this.state.selectedProblemCode}
                                            onChange={(e) => { this.setState({ selectedProblemCode: e }) }}                                          
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-4 mb-4 w-100">
                                        <label className="form-label catalog-label w-100"><Trans>Install customer</Trans></label>
                                        <Select id="installCustDD"
                                            options={this.state.InstallCustomerOptions}
                                            value={this.state.selectedInstallCustomer}
                                            className="PO-Work-DropDown-Font-Size"
                                            onChange={(e) => {
                                                if (e.value === "") {
                                                    this.setState({ selectedInstallCustomer: "" });
                                                } else {
                                                    this.setState({ selectedInstallCustomer: e });
                                                }
                                            }}
                                            name="INSTALLCUST"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`d-flex justify-content-end mt-5 custom-action-button-form pb-4 ${this.state.isapplyClick ? 'page-heading' : ''}`}>



                                    <button className="btn custom-btn-secondary secondary-btn px-4 mr-3 "
                                        disabled={(this.state.selectedShipTo == "" && this.state.selectedVendor == "" && this.state.selectedInstallStore == "" && this.state.selectedTechName == "" &&
                                            this.state.selectedProblemCode.length === 0 && this.state.selectedInstallCustomer == "" && this.state.selectedWOstatus == "" && this.state.poNumber == "" && this.state.workOrder == "")}
                                        onClick={() => this.setState({
                                            selectedShipTo: "", selectedVendor: "", selectedInstallStore: "", selectedTechName: "", selectedProblemCode: [], selectedInstallCustomer: "", selectedWOstatus: "",
                                            poNumber: "", workOrder: "", GridData: [], isapplyClick: false
                                        })}><Trans>Clear</Trans></button>

                                    <button className="btn custom-btn-primary px-4 m-0"
                                        disabled={this.state.selectedShipTo == "" && this.state.selectedVendor == "" && this.state.selectedInstallStore == "" && this.state.poNumber == "" && this.state.workOrder == ""}
                                        onClick={() => { this.applyFilterClick(1, "DUE_DT", "DESC", "", "", "N", "N", "Y") }}><Trans>Apply filter</Trans>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* Form Fields section Ends Here */}
                        {/* Accordion and Table Section Starts here */}

                        {this.state.GridData.length > 0 ?
                            <div className="col-md-12 p-0">
                                <div className="d-flex justify-content-end mt-4 custom-action-button-form ">
                                    <button className="btn custom-btn-primary px-4 m-0" onClick={() => { this.applyFilterClick(this.state.PageNo, this.state.SortColumn, this.state.SortType, "", "", "N", "Y", "N") }} ><Trans>Export to excel</Trans></button>


                                </div>
                                {/* Table starts here */}
                                <div className="mt-4">
                                    <table className="table mb-0 ZEUS_Grid mobileresponsive-grid powork-datepicker custom-poworkbench-table">
                                        <thead>
                                            <tr className="table-border-POWork" >
                                                <th />
                                                <th className="font-14 popover-item-cost"><Trans>Vendor name</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="VENDOR_NAME" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>
                                                <th className="font-14 popover-item-cost"><Trans>Work order</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="ISA_WORK_ORDER_NO" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>
                                                <th className="font-14 popover-item-cost"><Trans>PO date</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="PO_DT" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>

                                                <th className="font-14 popover-item-cost"><Trans>PO ID</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="PO_ID" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>

                                                <th className="font-14 popover-item-cost">
                                                    <Trans>Location</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="SHIPTO_ID" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>

                                                <th className="font-14 popover-item-cost">
                                                    <Trans>Tech name</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="ISA_EMPLOYEE_ID" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>
                                                <th className="font-14 popover-item-cost">
                                                    <Trans>WO priority</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="WO_PRIORITY" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>

                                                <th className="font-14 popover-item-cost">
                                                    <Trans>Order type</Trans>
                                                    <span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                        <img src="Images/table-sort-icon-bottom.svg" id="LINE_FIELD_C6" className='sort-icon asc' alt="sort-up" />
                                                    </span> 
                                                </th>
                                                <th className="font-14 popover-item-cost"><Trans>PO due date</Trans></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.GridData.length > 0 ? this.bindGridData() : null}
                                        </tbody>

                                    </table>


                                </div>

                                {/* Table Ends here */}



                                {/* Pagination Section Start here */}

                                <div className="col-md-12">
                                    {this.state.totalCount > 0 ? <>
                                        <div className="d-flex justify-content-between table-footer-responsive mt-3">
                                            <div>
                                                <span className="total-records mt-2 d-inline-block">
                                                    <Trans>Number of records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                                </span>
                                            </div>
                                            {this.state.totalCount > 10 ? <div> <ReactPaginate
                                                previousLabel={<span className="right-pagination-arrow" />}
                                                nextLabel={<span className="left-pagination-arrow" />}
                                                previousClassName={'page-item'}
                                                nextClassName={'page-item'}
                                                previousLinkClassName={'page-link'}
                                                nextLinkClassName={'page-link'}
                                                disabledClassName={'disabled'}
                                                breakLabel={'...'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                pageCount={this.state.pageCount}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={this.handlePagination}
                                                containerClassName={'custom-pagination pagination mb-5'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                hrefBuilder={() => '#'}
                                                forcePage={this.state.PageNo - 1}
                                            /></div> : null}
                                        </div> </> : null}
                                </div>

                            </div> : this.state.isapplyClick ?
                                <section className="site-undercontruction container text-center center-panel pt-4">
                                    <div className="img-section">
                                        {/* <img src="images/nosearch.jpg" alt="imagefile" />*/}
                                        <img
                                            className="mb-4 image-align"
                                            src="images/no-items-added-img.svg"
                                            alt="no-items-added"
                                        />
                                    </div>
                                    <p className="search-result-content pt-4"><Trans>No records found</Trans>
                                    </p>
                                </section> : null
                        }
                        {/* Pagination Section ends here */}



                        {/* Accordion and Table Section Starts here */}
                        {/*</div> */}

                    </div>


                </div>




                {/*Vendor Detail Modal starts here*/}
                <div className="modal fade bin-transfer-container vendor-detail-popup-container" id="VendorDetail" tabindex="-1" role="dialog" data-backdrop="static"
                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container border-0">
                            <div className="modal-header align-items-center">
                                <h5 className="fav-item-title m-0  fSoftware-Inventory-servicenowont-18 font-medium modal-title"><Trans>Vendor detail</Trans></h5>

                                <button type="button" className="btn py-0" data-dismiss="modal" >
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body terms-scroll m-3 pt-0 popup-info-container">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 p-0">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>City</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.City != " " && this.state.popupVendorDetail.City != null && this.state.popupVendorDetail.City != undefined ? this.state.popupVendorDetail.City : "-"}</td>

                                                </tr>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>State</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.State != " " && this.state.popupVendorDetail.State != null && this.state.popupVendorDetail.State != undefined ? this.state.popupVendorDetail.State : "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>Vendor</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.Name != " " && this.state.popupVendorDetail.Name != null && this.state.popupVendorDetail.Name != undefined ? this.state.popupVendorDetail.Name : "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>Address</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.Address1 != " " && this.state.popupVendorDetail.Address1 != null && this.state.popupVendorDetail.Address1 != undefined ? `${this.state.popupVendorDetail.Address1} ${this.state.popupVendorDetail.Address2}` : "-"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-6 col-md-12 p-0 pt-2">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>Vendor loc</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.VendorLoc != " " && this.state.popupVendorDetail.VendorLoc != null && this.state.popupVendorDetail.VendorLoc != undefined ? this.state.popupVendorDetail.VendorLoc : "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>Zip code</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.Postal != " " && this.state.popupVendorDetail.Postal != null && this.state.popupVendorDetail.Postal != undefined ? this.state.popupVendorDetail.Postal : "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="app-enhancements-sub-content py-2 vendor-popup-POWork align-top"><Trans>Contact</Trans>:</td>
                                                    <td className="font-14 app-enhancements-main-content py-2 pl-3 align-bottom">{this.state.popupVendorDetail.Phone != " " && this.state.popupVendorDetail.Phone != null && this.state.popupVendorDetail.Phone != undefined ? this.state.popupVendorDetail.Phone : "-"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Vendor detail Modal ends here*/}


                {/*Cancel Modal Starts here*/}
                <div className="modal fade expedite-panel-po-work-container" id="CancelPopUp" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-l custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container border-0 expedite-panel-item-details-container">
                            <div className="modal-header align-items-center">
                                <h4 className="modal-title mt-1 font-18 font-semibold"><Trans>Reason for cancel</Trans></h4>
                                <button type="button" className="btn py-0" data-dismiss="modal" onClick={() => this.clearFields(this.state.cancelindex)}>
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body terms-scroll py-0 pt-2">
                                {this.state.cancelindex != null ? this.bindCancelPopup() : null}
                            </div>
                        </div>
                    </div>
                </div>
                {/*Cancel Modal ends here*/}





                {/*More details Modal Starts here*/}
                <div className="modal fade expedite-panel-po-work-container" id="MoreDetailsPopUp" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-l custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container border-0 expedite-panel-item-details-container">
                            <div className="modal-header align-items-center">
                                <h4 className="modal-title mt-1 font-18 font-semibold"><Trans>More details</Trans></h4>
                                <button type="button" className="btn py-0" data-dismiss="modal" onClick={() => this.clearFields(this.state.gridLineIndex)}>
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body terms-scroll py-0 pt-2">
                                {this.state.gridLineIndex != null ? this.bindMoreDetailsPopup() : null}
                            </div>
                        </div>
                    </div>
                </div>
                {/*More details Modal ends here*/}



                {/*Success Modal Starts here*/}
                <div className="modal fade success-customer" id="powork-success-popup" tabIndex={-1} role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                        <div className="modal-content py-2">
                            {/*Success Starts here*/}
                            <div className="modal-body pb-2">
                                <div className="row">
                                    <div className="col-12 col-sm-12  col-md-12 col-lg-12 text-center">
                                        <img className="mb-3" src={this.state.isSuccess ? "images/tick.svg" : "images/caution.svg"} alt="tick" />
                                        <p className="mb-1 font-13 font-medium"><Trans>{this.state.popupMessage}</Trans></p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer border-0 d-flex justify-content-center pt-1">


                                <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2"
                                    data-dismiss="modal"
                                    onClick={() => {
                                        if (this.state.isSuccess) {
                                            this.applyFilterClick(this.state.PageNo, "DUE_DT", "DESC", "", "", "N", "N", "N");
                                        }
                                    }} >
                                    <Trans>OK</Trans>
                                </button>


                            </div>
                            {/*Success end here*/}
                        </div>
                    </div>
                </div>
                {/*Success Modal Ends here*/}



                {/* History Modal starts*/}
                <div className="modal fade expedite-panel-po-work-container" id="HistoryPopup" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container border-0">
                            <div className="modal-header align-items-center">
                                <h4 className="modal-title mt-1 fSoftware-Inventory-servicenowont-18 font-medium"><Trans>History</Trans></h4>
                                <button type="button" className="btn py-0" data-dismiss="modal">
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body terms-scroll py-3 popup-info-container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        {/*Table starts here*/}
                                        <div className="table-responsive mt-2">
                                            <table className="table split-delv-table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                                <thead>
                                                    <tr>
                                                        <th className="check-table-width"><Trans>Date</Trans></th>
                                                        <th className="position-sort-icon"><Trans>Comments</Trans></th>
                                                        <th className="position-sort-icon"><Trans>Problem code</Trans></th>
                                                        <th className="position-sort-icon"><Trans>Entered by</Trans></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.bindHistory()}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/*Table ends here*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* History Modal - ends */}


                {/*Attachments Modal Starts here*/}
                <div className="modal fade expedite-panel-po-work-container" id="attachmentPopup" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered" role="document">
                        <div className="modal-content custom-container border-0 expedite-panel-item-details-container">
                            <div className="modal-header align-items-center">
                                <h4 className="modal-title mt-1 font-18 font-semibold"><Trans>Add attachments</Trans></h4>

                                <button type="button" className="btn py-0" data-dismiss="modal" onClick={() => this.linelevelPopupDetails(this.state.gridLineIndex, "CANCELATTACH", "", "")} >
                                    <img src="images/close-icon.svg" alt="close-icon" />
                                </button>
                            </div>
                            <div className="modal-body py-0 pt-2" style={{ "max-height": "400px", "overflow-y": "auto" }}>
                                <div className="row mb-4 mt-2 documents-section">
                                    <div className="col-md-4 mb-3 pt-2">
                                        <p className="font-14 pt-2 mb-0"><Trans>Select file to attach</Trans></p>
                                    </div>
                                    <div className="col-md-8 mb-3 pt-2">

                                        <div className="parent-file-section position-relative">

                                            <div className="input-group charge-code-group">


                                                {/*<input type="file" id="search" className="form-control search-field search-width-full" data-toggle="modal" data-target="#quickconfirm" placeholder={t("Choose file...")} aria-label="Charge Code" aria-describedby="cc" onChange={e => this.handleAttachment(e)} /> */}
                                                <input
                                                    type="file"
                                                    multiple
                                                    className="custom-file-input"
                                                    accept="application/pdf,.jpg,.png,.jpeg"
                                                    id="attachment"
                                                    name="filename"
                                                    onChange={(e) => this.handleAttachment(e)}
                                                    data-content={t("Browse")}
                                                /><label className="custom-file-label" htmlFor="customFile"><Trans>Choose file...</Trans></label>




                                            </div>
                                        </div>



                                        {this.state.gridLineIndex != null ? (
                                            <>
                                                {this.bindAttachments()}
                                                <span className="font-14 font-regular color-validation" id="AttachError">
                                                    <Trans>{this.state.gridLineItemData[this.state.gridLineIndex]?.attachmentErrormsg}</Trans>
                                                </span>
                                            </>
                                        ) : null}

                                    </div>



                                    <div className="w-100 d-flex justify-content-end mt-3 pr-3">
                                        <button className="btn custom-btn-secondary-Cancel secondary-btn px-4 mr-3 primary-btn-responsive" data-dismiss="modal" onClick={() => this.linelevelPopupDetails(this.state.gridLineIndex, "CANCELATTACH", "",  "")}  ><Trans>Cancel</Trans></button>
                                        <button className="btn custom-btn-primary px-4 m-0" onClick={(e) => this.linelevelPopupDetails(this.state.gridLineIndex, "SAVECLICK", "", "")} ><Trans>Save</Trans></button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                {/* Modal - ends */}

            </>
        );
    };


}
export default withTranslation()(POWorkbenchComponent);